(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('harish-product-carousel-section')) {
  /*
   * Shared scheduler (used by every carousel on the page).
   * All carousels MEASURE first, then all of them WRITE, in one frame.
   */
  const batch = window.__harishCarouselBatch || (window.__harishCarouselBatch = {
    queue: new Set(),
    scheduled: false,
    add(carousel) {
      this.queue.add(carousel);
      if (this.scheduled) return;
      this.scheduled = true;
      requestAnimationFrame(() => this.flush());
    },
    flush() {
      this.scheduled = false;
      const items = Array.from(this.queue).filter((c) => c.isConnected);
      this.queue.clear();
      const measured = items.map((c) => c._measure()); // reads only
      items.forEach((c, i) => c._apply(measured[i]));   // writes only
    }
  });

  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      if (this._ready) {
        if (this._io) this._io.observe(this);
        return;
      }
      this._ready = true;

      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.dotsContainer = this.querySelector('[data-carousel-dots]');

      this.timer = null;
      this.resizeTimer = null;
      this.scrollFrame = null;
      this.settleTimer = null;
      this.pendingTimer = null;
      this.dragTimer = null;

      this._pendingPage = null;   // page we are animating to (arrows / dots / autoplay / drag release)
      this._interacting = false;  // user finger/mouse is on it, or it is still moving from their gesture
      this._pointerDown = false;
      this._suppressClick = false;
      this._posCache = null;
      this._posKey = '';
      this._activeIndex = -1;     // dot currently marked active (so we only write when it changes)
      this._animFrame = null;     // JS scroll animation (arrows / dots / autoplay / snap)
      this._snapTimer = null;     // waits for finger + momentum to stop, then snaps
      this._touchStartLeft = null;
      this._cardPos = null;       // scroll position of every card (snap points)

      this._visible = false;      // near the viewport? (heavy work only runs when it is)
      this._dirty = true;         // needs a (re)measure
      this._lastWidth = -1;       // track width at the last measure
      this._winWidth = window.innerWidth; // iOS: ignore height-only resizes (address bar)

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._mobileQuery = window.matchMedia('(max-width: 749px)');
      this._tabletQuery = window.matchMedia('(min-width: 750px) and (max-width: 989px)');
      this._desktopQuery = window.matchMedia('(min-width: 990px)');

      if (!this.track) return;

      this._cacheSlides();
      this._bindControls();
      this._bindEvents();
      this._observeVisibility();
    }

    disconnectedCallback() {
      this._stopAutoplay();
      this._cancelAnim();

      if (this._io) {
        this._io.disconnect();
      }

      if (this.track && this._boundScroll) {
        this.track.removeEventListener('scroll', this._boundScroll);
      }

      if (this.track && this._boundLoad) {
        this.track.removeEventListener('load', this._boundLoad, true);
      }

      if (this._boundResize) {
        window.removeEventListener('resize', this._boundResize);
      }

      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }

      if (this.track && this._boundPointerDown) {
        this.track.removeEventListener('pointerdown', this._boundPointerDown);
        this.track.removeEventListener('pointermove', this._boundPointerMove);
        this.track.removeEventListener('pointerup', this._boundPointerEnd);
        this.track.removeEventListener('pointercancel', this._boundPointerCancel);
        this.track.removeEventListener('lostpointercapture', this._boundPointerCancel);
        this.track.removeEventListener('click', this._boundClick, true);
        this.track.removeEventListener('dragstart', this._boundDragStart);
      }

      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      if (this.settleTimer) clearTimeout(this.settleTimer);
      if (this.pendingTimer) clearTimeout(this.pendingTimer);
      if (this.dragTimer) clearTimeout(this.dragTimer);
      if (this._snapTimer) clearTimeout(this._snapTimer);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
    }

    /* Only measure/build when the carousel is near the viewport.
       Off-screen carousels just stay "dirty" until they get close. */
    _observeVisibility() {
      if (!('IntersectionObserver' in window)) {
        this._visible = true;
        this._refresh();
        return;
      }

      this._io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this._visible = entry.isIntersecting;
          if (this._visible && this._dirty) batch.add(this);
        });
      }, { rootMargin: '300px 0px' });

      this._io.observe(this);
    }

    _cacheSlides() {
      this.slides = Array.from(this.track.children).filter(
        (el) => el.nodeType === 1
      );
    }

    /* Only real, visible cards count. Hidden helper elements
       (script/style/template, zero-width wrappers) are ignored. */
    _visibleSlides() {
      const ignored = ['SCRIPT', 'STYLE', 'TEMPLATE', 'LINK', 'NOSCRIPT'];

      return (this.slides || []).filter((el) => {
        if (ignored.indexOf(el.tagName) !== -1) return false;
        return el.getBoundingClientRect().width > 0;
      });
    }

    /* Read the exact HTML attribute instead of relying on DOMStringMap
       camel-case conversion. This is reliable in Shopify theme-editor iframes. */
    _attr(name, fallback = '') {
      const value = this.getAttribute(name);
      return value === null ? fallback : value;
    }

    _device() {
      if (this._mobileQuery.matches) return 'mobile';
      if (this._tabletQuery.matches) return 'tablet';
      return 'desktop';
    }

    _suffix() {
      const device = this._device();
      return device.charAt(0).toUpperCase() + device.slice(1);
    }

    _deviceAttr(base, fallback = '') {
      return this._attr('data-' + base + '-' + this._device(), fallback);
    }

    _columns() {
      const device = this._device();
      const raw = getComputedStyle(this)
        .getPropertyValue('--carousel-columns-' + device)
        .trim();

      return Math.max(1, Math.min(10, parseInt(raw, 10) || 1));
    }

    _isAuto() {
      return this._deviceAttr('width-mode', 'auto') === 'auto';
    }

    /*
     * Real scroll positions of each page, measured from the actual layout.
     * - Counts only visible cards.
     * - Works out how many cards really fit in one view.
     * - Clamps every page to the max scroll and removes duplicate positions,
     *   so the number of dots always equals the number of real stops.
     *
     * The result is cached (keyed by scrollWidth / clientWidth / card count)
     * so it is NOT re-measured on every scroll frame.
     */
    _positions() {
      const key =
        this.track.scrollWidth + '|' +
        this.track.clientWidth + '|' +
        (this.slides ? this.slides.length : 0);

      if (this._posCache && this._posKey === key) return this._posCache;

      const result = this._computePositions();

      this._posKey = key;
      this._posCache = result;

      return result;
    }

    _computePositions() {
      const slides = this._visibleSlides();

      if (!slides.length) {
        this._cardPos = [0];
        return [0];
      }

      const maxScroll = Math.max(
        0,
        this.track.scrollWidth - this.track.clientWidth
      );

      if (maxScroll <= 1) {
        this._cardPos = [0];
        return [0];
      }

      const gap =
        parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const cardWidth = slides[0].getBoundingClientRect().width;
      const perPage = Math.max(
        1,
        Math.round((this.track.clientWidth + gap) / (cardWidth + gap))
      );
      const base = this.track.offsetLeft;

      const cards = [];

      for (let i = 0; i < slides.length; i++) {
        const l = Math.min(maxScroll, Math.max(0, slides[i].offsetLeft - base));
        if (!cards.length || l - cards[cards.length - 1] > 2) cards.push(l);
      }

      this._cardPos = cards.length ? cards : [0];

      const positions = [];

      for (let i = 0; i < slides.length; i += perPage) {
        const left = Math.min(
          maxScroll,
          Math.max(0, slides[i].offsetLeft - base)
        );

        if (
          positions.length &&
          left - positions[positions.length - 1] <= 2
        ) {
          break;
        }

        positions.push(left);
      }

      return positions.length ? positions : [0];
    }

    _pageCount() {
      return this._positions().length;
    }

    _pageLeft(page) {
      const positions = this._positions();
      const safe = Math.max(0, Math.min(page, positions.length - 1));

      return positions[safe] || 0;
    }

    /* useCache = true is used by the scroll handler: it must NOT read
       scrollWidth/clientWidth every frame (that forces a layout while the
       finger is moving, which is what made iPhone swiping flicker). */
    _currentPage(useCache) {
      const positions = useCache && this._posCache ? this._posCache : this._positions();
      if (positions.length <= 1) return 0;

      const left = this.track.scrollLeft;
      let best = 0;
      let distance = Infinity;

      for (let page = 0; page < positions.length; page++) {
        const d = Math.abs(positions[page] - left);

        if (d < distance) {
          distance = d;
          best = page;
        }
      }

      return best;
    }

    /* Page we are currently on OR currently animating to.
       Fast repeated clicks / autoplay ticks never read a half-scrolled position. */
    _basePage() {
      return this._pendingPage !== null ? this._pendingPage : this._currentPage();
    }

    /*
     * JS scroll animation (arrows / dots / autoplay / mouse-drag release).
     * Native smooth scrollTo + scroll-snap fight each other in Safari (jump,
     * flicker, re-snap at the end). Here snap is OFF for the whole animation
     * (.is-dragging), the scroll lands exactly on the target position, and only
     * then snap comes back - so there is nothing left to re-snap.
     */
    _cancelAnim() {
      if (this._animFrame !== null) {
        cancelAnimationFrame(this._animFrame);
        this._animFrame = null;
      }
    }

    _finishAnim() {
      requestAnimationFrame(() => {
        if (this._animFrame === null && !this._dragState) {
          this.track.classList.remove('is-dragging');
        }
      });
    }

    _animateTo(left, dur) {
      this._cancelAnim();

      const start = this.track.scrollLeft;
      const dist = left - start;

      this.track.classList.add('is-dragging');

      if (Math.abs(dist) < 1 || this.reducedMotion) {
        this.track.scrollLeft = left;
        this._finishAnim();
        return;
      }

      const duration = dur || Math.min(600, Math.max(320, Math.abs(dist) * 0.6));
      const t0 = performance.now();

      const step = (now) => {
        const p = Math.min(1, (now - t0) / duration);
        const eased = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;

        this.track.scrollLeft = start + dist * eased;

        if (p < 1) {
          this._animFrame = requestAnimationFrame(step);
        } else {
          this._animFrame = null;
          this.track.scrollLeft = left;
          this._finishAnim();
        }
      };

      this._animFrame = requestAnimationFrame(step);
    }

    /* Wait until the finger is up AND the native momentum has stopped
       (no scroll events for a moment), then snap to the nearest card. */
    _queueSnap() {
      if (this._snapTimer) clearTimeout(this._snapTimer);
      if (this._pointerDown || this._dragState) return;

      this._snapTimer = setTimeout(() => {
        this._snapTimer = null;
        this._snapNow();
      }, 130);
    }

    _snapNow() {
      if (this._pointerDown || this._dragState || this._animFrame !== null) return;

      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const left = this.track.scrollLeft;

      /* rubber-band at the ends: let iOS finish bouncing back by itself */
      if (left <= 0 || left >= maxScroll) {
        this._touchStartLeft = null;
        return;
      }

      this._positions();
      const cards = this._cardPos || [0];

      const nearest = (x) => {
        let best = 0;
        let dist = Infinity;
        for (let i = 0; i < cards.length; i++) {
          const d = Math.abs(cards[i] - x);
          if (d < dist) {
            dist = d;
            best = i;
          }
        }
        return best;
      };

      let index = nearest(left);

      /* a short flick still moves one card in the flick direction */
      if (this._touchStartLeft !== null) {
        const startIndex = nearest(this._touchStartLeft);
        const moved = left - this._touchStartLeft;

        if (index === startIndex && Math.abs(moved) > 16) {
          index = Math.max(0, Math.min(cards.length - 1, index + (moved > 0 ? 1 : -1)));
        }
      }

      this._touchStartLeft = null;

      const target = cards[index];

      if (Math.abs(target - left) > 1) this._animateTo(target, 260);
    }

    _scrollToPage(page, clamp) {
      const count = this._pageCount();

      if (count <= 1) {
        this._setActivePage(0);
        if (!this._dragState) this.track.classList.remove('is-dragging');
        return;
      }

      const targetPage = clamp
        ? Math.max(0, Math.min(page, count - 1))
        : ((page % count) + count) % count;

      this._pendingPage = targetPage;

      if (this.pendingTimer) clearTimeout(this.pendingTimer);
      this.pendingTimer = setTimeout(() => {
        this.pendingTimer = null;
        this._pendingPage = null;
      }, 750);

      this._animateTo(this._pageLeft(targetPage));

      this._setActivePage(targetPage);
    }

    _next() {
      this._scrollToPage(this._basePage() + 1);
    }

    _prev() {
      this._scrollToPage(this._basePage() - 1);
    }

    _bindControls() {
      /* Arrow clicks are controls, never product/image drags. */

      if (this.prevButton) {
        this.prevButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this._next();
          this._restartAutoplay();
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this._prev();
          this._restartAutoplay();
        });
      }
    }

    _paginationUsesCardCount() {
      return this._deviceAttr('pagination-design', 'false') === 'true';
    }

    /*
     * Pagination always represents the real carousel stops, so the dot/line
     * count matches exactly what the carousel can scroll to.
     */
    _paginationCount() {
      return this._pageCount();
    }

    _paginationLeft(index) {
      return this._pageLeft(index);
    }

    _currentPaginationIndex() {
      return this._currentPage();
    }

    _scrollToPagination(index) {
      this._scrollToPage(index);
    }

    /* count / currentIndex are passed in by _apply() so nothing is re-measured
       right after the DOM was written (that was the forced reflow).
       If the number of dots did not change they are KEPT (not destroyed and
       recreated) - recreating them was visible as flicker. */
    _buildDots(knownCount, knownCurrent) {
      if (!this.dotsContainer) return;

      const count = knownCount !== undefined ? knownCount : this._paginationCount();
      const index = knownCurrent !== undefined ? knownCurrent : this._currentPaginationIndex();
      const current = Math.min(index, Math.max(0, count - 1));

      if (
        this.dots &&
        this.dots.length === count &&
        this.dotsContainer.children.length === count
      ) {
        this._activeIndex = -1;
        this._setActivePage(current);
        return;
      }

      this.dotsContainer.replaceChildren();
      this.dots = [];

      for (let page = 0; page < count; page++) {
        const dot = document.createElement('button');

        dot.type = 'button';
        dot.setAttribute(
          'aria-label',
          'Go to carousel page ' + (page + 1)
        );
        dot.setAttribute(
          'aria-current',
          page === current ? 'true' : 'false'
        );

        dot.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this._scrollToPagination(page);
          this._restartAutoplay();
        });

        this.dotsContainer.appendChild(dot);
        this.dots.push(dot);
      }

      this._activeIndex = current;
    }

    _setActivePagination(index) {
      this._setActivePage(index);
    }

    /* Only touches the DOM when the active dot really changes. */
    _setActivePage(page) {
      if (!this.dots || !this.dots.length) return;

      const safe = Math.max(
        0,
        Math.min(page, this.dots.length - 1)
      );

      if (safe === this._activeIndex) return;
      this._activeIndex = safe;

      this.dots.forEach((dot, index) => {
        dot.setAttribute(
          'aria-current',
          index === safe ? 'true' : 'false'
        );
      });
    }

    _onScroll() {
      if (this._animFrame === null && !this._pointerDown && !this._dragState) this._queueSnap();

      /* While the user's gesture is still moving the track (momentum),
         keep pushing the "settled" timer back so autoplay can't jump in. */
      if (this._interacting && !this._pointerDown) this._scheduleSettle();

      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;

        const index = this._pendingPage !== null
          ? this._pendingPage
          : this._currentPage(true);

        this._setActivePage(index);
      });
    }

    _updateControls(knownCount) {
      const onePage =
        (knownCount !== undefined ? knownCount : this._pageCount()) <= 1;

      if (this.prevButton) {
        this.prevButton.disabled = onePage;
      }

      if (this.nextButton) {
        this.nextButton.disabled = onePage;
      }

      // Keep the exact responsive setting on the element as the source of truth.
    }

    /* Debounced entry point (resize, breakpoint change, track resize).
       Off-screen carousels are only flagged; they measure when they get near. */
    _refresh() {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        this.resizeTimer = null;
        this._dirty = true;
        if (this._visible) batch.add(this);
      }, 30);
    }

    /* PHASE 1 - READ ONLY (no DOM writes in here). */
    _measure() {
      this._posCache = null;
      this._cacheSlides();

      if (!this.slides.length) return null;

      const count = this._pageCount();
      const current = this._currentPage();
      const width = this.track.clientWidth;

      return { count: count, current: current, width: width };
    }

    /* PHASE 2 - WRITE ONLY (uses the numbers measured above, reads nothing). */
    _apply(measured) {
      this._dirty = false;

      if (!measured) {
        this._stopAutoplay();
        this._updateControls(1);
        return;
      }

      this._lastWidth = measured.width;

      this._buildDots(measured.count, measured.current);
      this._updateControls(measured.count);

      /* Do not restart autoplay while the user is touching / the track is moving. */
      if (!this._interacting && this._animFrame === null) {
        this._restartAutoplay(measured.count);
      }
    }

    /* Called when the user lets go. Autoplay only resumes once the track
       has been completely still for a moment (no more jumping mid-swipe). */
    _scheduleSettle() {
      if (this.settleTimer) clearTimeout(this.settleTimer);

      this.settleTimer = setTimeout(() => {
        this.settleTimer = null;
        this._interacting = false;
        this._restartAutoplay();
      }, 250);
    }

    _beginInteraction() {
      this._pointerDown = true;
      this._interacting = true;
      this._pendingPage = null;

      if (this.settleTimer) {
        clearTimeout(this.settleTimer);
        this.settleTimer = null;
      }

      if (this._snapTimer) {
        clearTimeout(this._snapTimer);
        this._snapTimer = null;
      }

      this._stopAutoplay();
    }

    _bindEvents() {
      this._boundScroll = () => this._onScroll();

      /*
       * MOUSE drag only.
       * Touch is left 100% to the browser's native scroll + snap, which is what
       * removes the glitch / jump-to-first / not-moving problems on phones.
       */
      this._dragState = null;

      this._boundPointerDown = (event) => {
        if (event.pointerType !== 'mouse') return;
        if (event.button !== undefined && event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea')) return;

        this._cancelAnim();
        this._beginInteraction();

        this._dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          startScrollLeft: this.track.scrollLeft,
          startPage: this._currentPage(),
          lastX: event.clientX,
          lastT: performance.now(),
          velocity: 0,
          dragging: false,
        };
      };

      this._boundPointerMove = (event) => {
        const state = this._dragState;
        if (!state || state.pointerId !== event.pointerId) return;

        const dx = event.clientX - state.startX;
        const dy = event.clientY - state.startY;

        if (!state.dragging) {
          if (Math.abs(dy) > Math.abs(dx) || Math.abs(dx) < 6) return;
          state.dragging = true;
          this.track.classList.add('is-dragging');
          this.track.style.cursor = 'grabbing';
          try { this.track.setPointerCapture(event.pointerId); } catch (e) {}
        }

        event.preventDefault();

        const now = performance.now();
        const dt = now - state.lastT;

        if (dt > 0) {
          const v = (event.clientX - state.lastX) / dt;
          state.velocity = state.velocity * 0.6 + v * 0.4;
          state.lastX = event.clientX;
          state.lastT = now;
        }

        this.track.scrollLeft = state.startScrollLeft - dx;
      };

      this._boundPointerEnd = (event) => {
        const state = this._dragState;
        if (!state || state.pointerId !== event.pointerId) return;

        this._dragState = null;
        this._pointerDown = false;
        this.track.style.cursor = 'grab';
        try { this.track.releasePointerCapture(event.pointerId); } catch (e) {}

        if (!state.dragging) {
          this.track.classList.remove('is-dragging');
          this._scheduleSettle();
          return;
        }

        event.preventDefault();

        /* stop the click that follows a drag from opening a product link */
        this._suppressClick = true;
        setTimeout(() => { this._suppressClick = false; }, 60);

        const dx = event.clientX - state.startX;
        const threshold = Math.max(40, this.track.clientWidth * 0.10);
        const flick = Math.abs(state.velocity) > 0.5 && Math.abs(dx) > 20;

        let page = state.startPage;

        if (Math.abs(dx) >= threshold || flick) {
          // Drag left = next page, drag right = previous page. No wrap-around on drag.
          page += dx < 0 ? 1 : -1;
        }

        this._scrollToPage(page, true);
        this._scheduleSettle();
      };

      this._boundPointerCancel = (event) => {
        const state = this._dragState;
        if (!state || state.pointerId !== event.pointerId) return;

        this._dragState = null;
        this._pointerDown = false;
        this.track.style.cursor = 'grab';
        try { this.track.releasePointerCapture(event.pointerId); } catch (e) {}

        if (state.dragging) {
          this._scrollToPage(this._currentPage(), true);
        } else {
          this.track.classList.remove('is-dragging');
        }

        this._scheduleSettle();
      };

      this._boundClick = (event) => {
        if (!this._suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      };

      this._boundDragStart = (event) => {
        event.preventDefault();
      };

      this.track.addEventListener('pointerdown', this._boundPointerDown);
      this.track.addEventListener('pointermove', this._boundPointerMove, { passive: false });
      this.track.addEventListener('pointerup', this._boundPointerEnd, { passive: false });
      this.track.addEventListener('pointercancel', this._boundPointerCancel);
      this.track.addEventListener('lostpointercapture', this._boundPointerCancel);
      this.track.addEventListener('click', this._boundClick, true);
      this.track.addEventListener('dragstart', this._boundDragStart);

      /* iOS FIX: Safari fires `resize` when the address bar shows/hides while
         scrolling (height-only change). Only react when the width really changed. */
      this._boundResize = () => {
        const w = window.innerWidth;
        if (w === this._winWidth) return;
        this._winWidth = w;
        this._refresh();
      };

      this.track.addEventListener(
        'scroll',
        this._boundScroll,
        { passive: true }
      );

      /* Images finishing loading can change card sizes after the first measure. */
      this._boundLoad = () => this._refresh();
      this.track.addEventListener('load', this._boundLoad, true);

      window.addEventListener(
        'resize',
        this._boundResize,
        { passive: true }
      );

      const mediaQueries = [
        this._mobileQuery,
        this._tabletQuery,
        this._desktopQuery
      ];

      mediaQueries.forEach((query) => {
        const handler = () => this._refresh();
        query.addEventListener
          ? query.addEventListener('change', handler)
          : query.addListener(handler);
      });

      /* Re-count when the track really changes size. The very first
         notification (same width we already measured) is ignored, so the
         page is not measured twice at load. */
      if (window.ResizeObserver) {
        this._resizeObserver = new ResizeObserver((entries) => {
          const entry = entries[0];
          const width = entry ? entry.contentRect.width : 0;
          if (Math.abs(width - this._lastWidth) < 0.5) return;
          this._refresh();
        });
        this._resizeObserver.observe(this.track);
      }

      /* iOS FIX: a tap fires an emulated mouseenter but mouseleave often never
         comes, which left autoplay stopped. Hover pause is real-mouse only. */
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this._stopAutoplay();
      });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this._startAutoplay();
      });

      this.addEventListener('focusin', () => this._stopAutoplay());
      this.addEventListener('focusout', () => this._startAutoplay());

      /* Finger: pause autoplay while touching AND while the swipe momentum is running.
         If a JS animation is still running, the finger takes over from it. */
      this.addEventListener(
        'touchstart',
        () => {
          if (this._animFrame !== null) {
            this._cancelAnim();
            this.track.classList.remove('is-dragging');
          }
          this._touchStartLeft = this.track.scrollLeft;
          this._beginInteraction();
        },
        { passive: true }
      );

      this.addEventListener(
        'touchend',
        () => {
          this._pointerDown = false;
          this._scheduleSettle();
          this._queueSnap();
        },
        { passive: true }
      );

      this.addEventListener(
        'touchcancel',
        () => {
          this._pointerDown = false;
          this._scheduleSettle();
          this._queueSnap();
        },
        { passive: true }
      );
    }

    _startAutoplay(knownCount) {
      this._stopAutoplay();

      if (
        this._deviceAttr('autoplay', 'false') !== 'true' ||
        (knownCount !== undefined ? knownCount : this._pageCount()) <= 1 ||
        this.reducedMotion
      ) {
        return;
      }

      const speed =
        parseInt(this._deviceAttr('speed', '4000'), 10) || 4000;

      this.timer = window.setInterval(() => {
        if (this._interacting || this._pointerDown) return;
        this._next();
      }, speed);
    }

    _stopAutoplay() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    _restartAutoplay(knownCount) {
      this._startAutoplay(knownCount);
    }
  }

  customElements.define('harish-product-carousel-section', ProductCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
